module.exports = __webpack_public_path__ + "img/99.8d54aa25.jpg";